import React from 'react';
import { Box } from '@common-fe/common-fe';

import ExpressSetupFAQItem from './ExpressSetupFAQItem';
import { useFAQWithDynamicDays } from './hooks';

interface Props {
  isLoading?: boolean;
  numberOfDaysBeforePlanStart?: number;
}

const ExpressSetupFAQ: React.FC<Props> = ({
  numberOfDaysBeforePlanStart,
  isLoading,
}) => {
  const dynamicFAQArray = useFAQWithDynamicDays(numberOfDaysBeforePlanStart);
  return (
    <Box gap="s">
      {dynamicFAQArray?.map((item, index) => (
        <ExpressSetupFAQItem 
          key={index} 
          question={item.question} 
          answer={item.answer} 
          isLoading={isLoading}
          index={index}
          isPageMode
        />
      ))}
    </Box>
  );
};
export default ExpressSetupFAQ;
